import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Logo.png";

export default function Header() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleMenu = () => {
    navigate("/menu"); // HomePage.js
  };

  return (
    <div style={styles.header}>
      {/* LEFT: LOGO + BACK/MENU BELOW */}
      <div style={styles.left}>
        <img src={logo} alt="Company Logo" style={styles.logo} />

        <div style={styles.navRow}>
          <button style={styles.navBtn} onClick={handleBack}>
            ⬅ Back
          </button>

          <button style={styles.navBtn} onClick={handleMenu}>
            ☰ Menu
          </button>
        </div>
      </div>

      {/* RIGHT: USER + LOGOUT */}
      <div style={styles.right}>
        <span style={styles.userName}>
          {user?.empName || "User"}
        </span>

        <button style={styles.logoutBtn} onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}

/* ---------------- STYLES ---------------- */
const styles = {
  header: {
    height: "90px",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 1.5rem",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },

  left: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.3rem",
  },

  logo: {
    height: "55px",
    objectFit: "contain",
  },

  navRow: {
    display: "flex",
    gap: "0.5rem",
  },

  navBtn: {
    background: "#fafafaff",
    border: "1px solid #ccc",
    borderRadius: "6px",
    padding: "0.3rem 0.8rem",
    cursor: "pointer",
    fontWeight: "500",
  },

  right: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "0.35rem",
  },

  userName: {
    fontWeight: "700",
    color: "#333",
  },

  logoutBtn: {
    background: "#E30016",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "0.45rem 1rem",
    cursor: "pointer",
    fontWeight: "600",
  },
};
